import React, { createContext, useContext, FC, RefObject, useRef } from 'react';

export interface PageScrollContextValue {
  topPageRef: RefObject<HTMLDivElement>;
}

const PageScrollContext = createContext<PageScrollContextValue>({
  topPageRef: { current: null },
});

export const PageScrollContextProvider: FC = ({ children }) => {
  const topPageRef = useRef<HTMLDivElement>(null);

  return (
    <PageScrollContext.Provider value={{ topPageRef }}>
      {children}
    </PageScrollContext.Provider>
  );
};

export const usePageScroll = () => {
  const { topPageRef } = useContext(PageScrollContext);

  const scrollToTop = (options?: ScrollIntoViewOptions) =>
    topPageRef.current?.scrollIntoView(options ?? true);

  return { scrollToTop, topPageRef };
};
